import React, { useState } from 'react';
import { Link } from 'react-router-dom';

interface CustomLinkProps {
  to: string;
  label: string;
  target?: string;
  style?: React.CSSProperties;
}

const CustomLink: React.FC<CustomLinkProps> = ({ to, target, label, style }) => {
  const [isHovered, setIsHovered] = useState(false);

  const defaultStyle: React.CSSProperties = {
    textDecoration: isHovered ? 'underline' : 'none',
  };

  const linkStyle = { ...defaultStyle, ...style };

  return (
    <Link
      to={to}
      target={target}
      rel="noopener noreferrer"
      style={linkStyle}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {label}
    </Link>
  );
};

export default CustomLink;
